import {observable, action} from 'mobx';
import _ from 'lodash';
import shortid from 'shortid';
class CategoryStore {

  @observable categories = [];

  @observable isSingle = false;

  @action
  setCategories = categories => {
    this.categories = categories;
    this.isSingle = false;
  };

  getTutorialsById = id => {
    return this.getCategoryById(id).tutorials
  };

  @action
  setCategory = category => {
    this.categories = [category];
    this.isSingle = true;
  };

  getCategoryById = id => {
    return this.categories.find( el => el.id === id)
  };

  @action
  handleUpdateCategory = newCategory => {
    let oldCategory = this.getCategoryById(newCategory.id);
    _.assign(oldCategory, newCategory);
  };

  @action
  createCategory = category => {
    this.categories.unshift(category)
  };

  @action
  deleteCategory = id => {
    let index = _.findIndex(this.categories, el => el.id === id );
    this.categories.splice(index,1);
  };

  getTutorialById = (categoryId, tutorialId) => {
    return this.getTutorialsById(categoryId).find(el => el.id === tutorialId)
  };

  @action
  deleteTutorial = (categoryId, tutorials) => {
    this.getCategoryById(categoryId).tutorials = tutorials;
    this.getCategoryById(categoryId).tutorials_count--;
  };

  @action
  createTutorialOnList = (categoryId, tutorial) => {
    _.assign(tutorial, {stubKey: _.assign(shortid.generate())});
    this.getCategoryById(categoryId).tutorials_count++;
    let tutorials = this.getCategoryById(categoryId).tutorials;
    tutorials.unshift(tutorial);
    let length = tutorials.length;
    if(length > 3)
      tutorials.splice(length - 1, 1);
  };

  @action
  createTutorialOnShow = (categoryId, tutorial) => {
    _.assign(tutorial, {stubKey: _.assign(shortid.generate())});
    let tutorials = this.getCategoryById(categoryId).tutorials;
    this.getCategoryById(categoryId).tutorials_count++;
    tutorials.unshift(tutorial)
  };

  @action
  deleteTutorialOnShow = (categoryId, tutorialId) => {
    let tutorials = this.getCategoryById(categoryId).tutorials;
    this.getCategoryById(categoryId).tutorials_count--;
    let index = _.findIndex(tutorials, e => e.id === tutorialId);
    tutorials.splice(index, 1);
  };

  @action
  updateTutorial = (categoryId, tutorial) => {
    _.assign(tutorial, {stubKey: _.assign(shortid.generate())});
    let tutorials = this.getCategoryById(tutorial.category_id).tutorials;
    let oldTutorialIndex = tutorials.findIndex(e => e.id === tutorial.id);
    tutorials[oldTutorialIndex] = tutorial
  }

}

export default new CategoryStore();



// WEBPACK FOOTER //
// ./src/stores/CategoryStore.js